import AsyncStorage from '@react-native-async-storage/async-storage';
import { setTenantId } from './tenant/selected.js';
let _currentLang = null;
export const setCurrentLang = (currentLang) => {
    AsyncStorage.setItem('currentLang', JSON.stringify(currentLang));
    _currentLang = currentLang;
};
// We might want to consolidate some of these variables into a common state/model
let _exclusiveContent = [];
export const setExclusiveContent = (ids) => {
    AsyncStorage.setItem('exclusiveContent', JSON.stringify(ids));
    _exclusiveContent = ids;
};
let _creditorId = null;
export const setSelectedCreditorId = (id) => {
    if (id === null) {
        AsyncStorage.removeItem('selectedCreditorId');
    }
    else {
        AsyncStorage.setItem('selectedCreditorId', id);
        _creditorId = id;
    }
};
// Variables which are used globally in the module
// I think ideally this should not exist due to possible bundling issues, but might be fine for now
let _token = '';
export const setAuthToken = (token) => {
    if (token === '') {
        AsyncStorage.removeItem('authToken');
    }
    else {
        AsyncStorage.setItem('authToken', token);
    }
    _token = token;
};
let _tribunalKey = '';
export const setTribunalKey = (key) => {
    if (key === '') {
        AsyncStorage.removeItem('tribunalKey');
    }
    else {
        AsyncStorage.setItem('tribunalKey', key);
    }
    _tribunalKey = key;
};
// Global state update dispatcher
let _dispatch = (action) => { };
export const setDispatch = (dispatch) => {
    _dispatch = dispatch;
};
// Data in storage should be cleared if the auth token is changed
const initURL = async () => {
    const queryTenantId = window.location
        ? new URLSearchParams(window.location.search).get('tenantId')
        : null;
    const queryCreditorId = window.location
        ? new URLSearchParams(window.location.search).get('creditorId')
        : null;
    const queryAuthToken = window.location
        ? new URLSearchParams(window.location.search).get('authToken')
        : null;
    // AUTH TOKEN
    const authTokenLocalStorage = await AsyncStorage.getItem('authToken');
    // If authToken is in a queryparam: Save it and remove it from the URL
    if (!authTokenLocalStorage && !queryAuthToken) {
        await clearStorage();
    }
    if (queryAuthToken) {
        if (!authTokenLocalStorage || queryAuthToken !== authTokenLocalStorage) {
            await clearStorage();
            setAuthToken(queryAuthToken);
        }
    }
    // tenantId
    if (queryTenantId) {
        setTenantId(queryTenantId);
    }
    // creditorid
    if (queryCreditorId) {
        setSelectedCreditorId(queryCreditorId);
    }
    // Remove query params
    if (queryAuthToken || queryTenantId || queryCreditorId) {
        if (window.history) {
            console.log(window.location.pathname);
            // Preserve other query params
            let searchParams = new URLSearchParams(window.location.search);
            searchParams.delete('creditorId');
            searchParams.delete('tenantId');
            searchParams.delete('authToken');
            const queryString = searchParams.toString();
            window.history.pushState(document.title, document.title, `${window.location.pathname}${queryString ? '?' : ''}${queryString}`);
        }
    }
};
export const clearStorage = async () => {
    const keys = await AsyncStorage.getAllKeys();
    await AsyncStorage.multiRemove(keys);
};
export const populateInternal = async () => {
    await initURL();
    const [currentLang, exclusiveContent, creditor, tribunalKey, authToken] = await Promise.all([
        AsyncStorage.getItem('currentLang'),
        AsyncStorage.getItem('exclusiveContent'),
        AsyncStorage.getItem('selectedCreditorId'),
        AsyncStorage.getItem('tribunalKey'),
        AsyncStorage.getItem('authToken'),
    ]);
    _currentLang = currentLang ? JSON.parse(currentLang) : null;
    _exclusiveContent =
        exclusiveContent != null ? JSON.parse(exclusiveContent) : [];
    _creditorId = creditor ? creditor : null;
    _token = authToken || '';
    _tribunalKey = tribunalKey || '';
};
export { _dispatch as dispatch, _token as authToken, _exclusiveContent as exclusiveContent, _creditorId as selectedCreditorId, _currentLang as currentLang, _tribunalKey as tribunalKey, };
//# sourceMappingURL=internal.js.map